"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VenusFirst = void 0;
var Tags_1 = require("../Tags");
var PreludeCard_1 = require("../prelude/PreludeCard");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var VenusFirst = (function (_super) {
    __extends(VenusFirst, _super);
    function VenusFirst() {
        return _super.call(this, {
            name: CardName_1.CardName.VENUS_FIRST,
            tags: [Tags_1.Tags.VENUS],
            metadata: {
                cardNumber: 'Y07',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.venus(2).br.br;
                    b.cards(2).secondaryTag(Tags_1.Tags.VENUS);
                }),
                description: 'Raise Venus 2 steps. Draw 2 Venus cards from the deck.',
            },
        }) || this;
    }
    VenusFirst.prototype.play = function (player) {
        player.game.increaseVenusScaleLevel(player, 2);
        player.drawCard(2, { tag: Tags_1.Tags.VENUS });
        return undefined;
    };
    return VenusFirst;
}(PreludeCard_1.PreludeCard));
exports.VenusFirst = VenusFirst;
//# sourceMappingURL=VenusFirst.js.map